import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Listserviceapp(props) {
  return (
    <div className="list_service_app p-100" style={{ background: "#F9F9F9" }}>
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto ">
            <StaticImage
              src="../../../images/solution/ecommerce/Ecommerce-Apps.webp"
              alt="Ecommerce app development company"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={775}
              height={650}
            />
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2 style={{ color: "#314252" }}>
              How Many Types of Ecommerce Apps Can We Develop?
            </h2>
            <p style={{ color: "#000" }}>
              Ecommerce apps are not just useful for B2C businesses. They are
              now being used and developed to suit all kinds of digital consumer
              interactions. Whatever you sell, you can do it through an
              Ecommerce app.
            </p>
            <p style={{ color: "#000" }}>
              Being a top-rated Ecommerce app development company, we can offer
              the following kinds of Ecommerce application development solutions
              for you:
            </p>
            <ul>
              <li style={{ color: "#314252" }}>Consumer To Consumer</li>
              <li style={{ color: "#314252" }}>E-Marketplace</li>
              <li style={{ color: "#314252" }}>Business to Business</li>
              <li style={{ color: "#314252" }}>Business To Consumer</li>
              <li style={{ color: "#314252" }}>
                Second Hand Goods Marketplace
              </li>
            </ul>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
              style={{ background: "transparent" }}
            >
              Get your Ecommerce App
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Listserviceapp;
